import React, { CSSProperties } from "react";
import { CompanyEmployeeInviteDto } from "shared/api";
import { Avatar, Entity } from "shared/ui";

export interface IEmployeeInviteEntity {
  data: CompanyEmployeeInviteDto;
  menuItems?: React.ReactNode;
  className?: string;
  style?: CSSProperties;
  htmlId?: string;
}

export const EmployeeInviteEntity = (props: IEmployeeInviteEntity) => (
  <Entity className={props.className} style={props.style} htmlId={props.htmlId} menuItems={props.menuItems}>
    <Entity.Field
      avatar={<Avatar id={props.data.id} name={props.data.email} />}
      title="Отправленное приглашение"
      description={props.data.email}
    />
    <Entity.Field description={props.data.companyEmployeeRole.name} right />
  </Entity>
);

EmployeeInviteEntity.defaultProps = {};
